'use client';

import { useGlobalClientContext } from '../../../modules/common/GlobalClientContext';
import React from 'react';
import { convertBoldTagsToStrong } from '@altus-ui/components_v2/utils/text';
import { I18nResKeys } from '@altus-ui/i18n/messages/i18n-types';

export default function ConsentPersonalInformationV1() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();
  const getText = (key: string) => t(key as I18nResKeys, {});
  const formatBold = (key: string) => convertBoldTagsToStrong(getText(key));

  return (
    <div className="flex flex-col text-sm text-primary leading-md not-italic">
      <p className="font-regular whitespace-pre-wrap">
        {formatBold('collection.and.use.of.personal.information_1st_paragraph')}
      </p>

      <br />

      <div className="flex flex-col">
        <p className="font-semibold whitespace-pre-wrap">
          {formatBold(
            'collection.and.use.of.personal.information_1st.section_title'
          )}
        </p>
        <ul className="flex flex-col">
          <li className="flex items-start font-regular whitespace-pre-wrap">
            <span>•</span>
            <span>
              {formatBold(
                'collection.and.use.of.personal.information_1st.section_1st.bullet'
              )}
            </span>
          </li>
          <li className="flex items-start font-regular whitespace-pre-wrap">
            <span>•</span>
            <span>
              {formatBold(
                'collection.and.use.of.personal.information_1st.section_2nd.bullet'
              )}
            </span>
          </li>
        </ul>
      </div>

      <br />

      <div className="flex flex-col">
        <p className="font-semibold whitespace-pre-wrap">
          {formatBold(
            'collection.and.use.of.personal.information_2nd.section_title'
          )}
        </p>
        <p className="font-regular whitespace-pre-wrap">
          {formatBold(
            'collection.and.use.of.personal.information_2nd.section_content'
          )}
        </p>
      </div>

      <br />

      <div className="flex flex-col">
        <p className="font-semibold whitespace-pre-wrap">
          {formatBold(
            'collection.and.use.of.personal.information_3rd.section_title'
          )}
        </p>
        <p className="font-semibold whitespace-pre-wrap">
          {formatBold(
            'collection.and.use.of.personal.information_3rd.section_content'
          )}
        </p>
      </div>
    </div>
  );
}
